import { render, staticRenderFns } from "./FiltroPreCotacao.vue?vue&type=template&id=60bc7a49&scoped=true&"
import script from "./FiltroPreCotacao.vue?vue&type=script&lang=js&"
export * from "./FiltroPreCotacao.vue?vue&type=script&lang=js&"
import style0 from "./FiltroPreCotacao.vue?vue&type=style&index=0&id=60bc7a49&prod&scoped=true&lang=css&"
import style1 from "./FiltroPreCotacao.vue?vue&type=style&index=1&id=60bc7a49&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bc7a49",
  null
  
)

export default component.exports